import React from 'react';

export default function AuthenticationWrapper({ children, viewAsRole, permissions = [], byPass }) {
  if (permissions.includes(viewAsRole) || byPass) return <>{children}</>;
  return null;
}
